import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'atomic-so-mat-modal',
  standalone: true,
  templateUrl: './so-mat-modal.component.html',
  styleUrl: './so-mat-modal.component.scss'
})
export class SoMatModalComponent {
  
  constructor(public dialogRef: MatDialogRef<SoMatModalComponent>) { }

  onCloseClick(): void {
    this.dialogRef.close();
  }

}
